import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
    Subheader
} from "../../components";
import { AlertContext, BackdropContext } from "../../contexts";
import { AlertProps, NetWorkCallMethods } from "../../utils";
import { DetailCard } from "./detailsCard";
import { NetworkCall } from '../../networkcall';
import { config } from '../../config';


export const UnitVacancyDetails = () => {
    const navigate = useNavigate()
    const [data, setData] = React.useState([])
    const search = useLocation().search;
    const alert = React.useContext(AlertContext);
    const propertyID = new URLSearchParams(search).get("propertyID");
    const backdrop = React.useContext(BackdropContext);


    const getPropertyById = () => {
        const payload={
            propertyID:propertyID
        }
        NetworkCall(
            `${config.api_url}/queries/property/get`,
            NetWorkCallMethods.post,
            payload,
            null,
            true,
            false).then((res) => {
            backdrop.setBackDrop({
                ...backdrop,
                open: false,
                message: "",
            });
            setData(res?.data?.data)
        }).catch((err) => {
            console.log(err)
            alert.setSnack({
                ...alert,
                open: true,
                severity: AlertProps.severity.error,
                msg: "Something went wrong please try again",
                vertical: AlertProps.vertical.top,
                horizontal: AlertProps.horizontal.center
            });
        });
    };

    React.useEffect(() => {
        backdrop.setBackDrop({
            ...backdrop,
            open: true,
            message: "",
        });
        getPropertyById()
        // eslint-disable-next-line
    }, [])
    const goBack = () => {
        navigate(-1)
    }

    return (
        <div >
            <Subheader title={data?.property?.[0]?.name} goBack={goBack} select isReadOnly={true} value={data?.property?.[0]?.company} />
            <DetailCard data={data?.property?.[0]} assets={data?.asset} />
        </div >
    )
}